<template>
  <div class="introduce">
    <div class="banner">
      <div class="main_width">
        <h2 class="wow fadeInDown">快贴宝平台介绍</h2>
        <p class="wow fadeInUp">快贴宝平台是豆伴旗下的票据综合服务平台，支持银票快贴和商票速融，为中小微企业提供更高效、便捷、合规的票据融资服务，服务实体经济发展。目前，银票快贴已接入6家+银行，服务超过5万家小微企业。商票速融可以帮助中小企业完成商票融资，覆盖建筑工程、金属、材料、军工、地产等行业，可快速缓解企业现金流压力。</p>
      </div>
    </div>
    <div class="introduce-main">
      <div class="introduce-main-topImg">
        <div class="introduce-main-leftImg wow slideInLeft"></div>
        <div class="introduce-main-rightC wow slideInRight">
          <div class="introduce-main-rightC-topImg"></div>
          <div class="introduce-main-rightC-pDiv">
            <p>银票快贴为企业解决贴现繁琐，成本高的难题， 以<span>“银企直连”</span>的方式与多家银行携手为企业提供快捷、专业的票据线上报价贴现服务。</p>
          </div>
          <div class="introduce-main-rightC-btn" @click="$router.push('/ApplicationDiscount')"></div>
        </div>
      </div>
      <div class="introduce-main-top"></div>

      <!--银票快贴与传统银行贴现对比-->
      <div class="introduce-main-bankDifferent">
        <h2 class="wow flipInY">银票快贴与传统银行贴现对比</h2>
        <div class="introduce-main-bankDifferent-main wow fadeInRight">
          <div class="introduce-main-bankDifferent-main-title">
            <div class="introduce-main-bankDifferent-main-title-l">银票快贴优势</div>
            <div class="introduce-main-bankDifferent-main-title-r">传统银行贴现痛点</div>
          </div>
          <ul class="introduce-main-bankDifferent-main-list">
            <li>
              <div>
                <i class="icon-bank"></i>
                <div class="introduce-main-bankDifferent-main-list-con">
                  <p>合规银行</p>
                  <p>国家正规银行，安全放心！</p>
                </div>
              </div>
              <div>
                <i class="icon-shijian"></i>
                <div class="introduce-main-bankDifferent-main-list-con">
                  <p>时间成本大</p>
                  <p>需要跑到银行开户，消耗大量的时间成本</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <i class="icon-supei"></i>
                <div class="introduce-main-bankDifferent-main-list-con">
                  <p>聚合报价</p>
                  <p>牵手10余家银行，快速匹配最优银行价格</p>
                </div>
              </div>
              <div>
                <i class="icon-xunzhao"></i>
                <div class="introduce-main-bankDifferent-main-list-con">
                  <p>寻找贴现渠道</p>
                  <p>需要自己寻找贴现渠道，价格偏差不等</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <i class="icon-miaoji"></i>
                <div class="introduce-main-bankDifferent-main-list-con">
                  <p>安全秒到</p>
                  <p>10秒到账，款回贴现户</p>
                </div>
              </div>
              <div>
                <i class="icon-yewu"></i>
                <div class="introduce-main-bankDifferent-main-list-con">
                  <p>业务时间长</p>
                  <p>贴现业务流程从贴现到回款在3个工作日以上</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <i class="icon-pinzheng"></i>
                <div class="introduce-main-bankDifferent-main-list-con">
                  <p>合法凭证</p>
                  <p>获取贴现凭证，财务做账无忧</p>
                </div>
              </div>
              <div></div>
            </li>
          </ul>
        </div>
      </div>

      <!--在线贴现流程-->
      <div class="introduce-main-online">
        <h2 class="wow flipInX">在线贴现流程</h2>
        <div class="introduce-main-online-con">
          <ul class="wave-line-img">
            <li class="normalStyle wave-line-img-li1 wow pulse" data-wow-delay="0.5s">
              <i class="icon-tijiao iconCircleStyle"></i>
              <span class="line"></span>
              <i class="san"></i>
              <p><span>01.</span>提交承兑汇票信息</p>
            </li>
            <li class="specalStyle wave-line-img-li2 wow pulse" data-wow-delay="1s">
              <p><span>02.</span>获取报价，选择贴入行</p>
              <i class="daoSan"></i>
              <span class="line"></span>
              <i class="icon-huoqu iconCircleStyle"></i>
            </li>
            <li class="normalStyle wave-line-img-li3 wow pulse" data-wow-delay="1.5s">
              <i class="icon-caozuo iconCircleStyle"></i>
              <span class="line"></span>
              <i class="san"></i>
              <p><span>03.</span>操作网银贴现</p>
            </li>
            <li class="normalStyle wave-line-img-li4 wow pulse" data-wow-delay="2s">
              <i class="icon-pinzheng iconCircleStyle"></i>
              <span class="line"></span>
              <i class="san"></i>
              <p><span>04.</span>贴现成功，银行回款，获取凭证</p>
            </li>
          </ul>

        </div>
      </div>
    </div>

    <div class="introduce-business-bg"></div>
    <div class="introduce-business">
      <div class="main_width introduce-business-part1">
        <div class="introduce-business-part1-l wow slideInDown">
          <img src="~@/assets/img/platformIntroduce/shangpiaosurong@2x.png" alt="">
          <div class="introduce-business-part1-l-pDiv">
            <p>
              商票速融是基于核心企业信用为上游供应商提供的电子商票在线融资服务，可有力助推核心企业商业信用流通，帮助核心企业降低供应链综合财务成本，<span>为持票人提供低门槛低成本快速融资</span>。
            </p>
          </div>
          <div class="introduce-business-part1-btn" @click="$router.push('/BusinessTicketDiscount')"></div>
        </div>
        <div class="introduce-business-part1-r wow slideInUp"></div>
      </div>
      <div class="introduce-business-part2">
        <div class="main_width introduce-business-part2-main">
          <h2 class="wow flipInY">商票在线快贴流程</h2>
          <div>
            <img class="introduce-business-part2-main-l wow slideInLeft" src="~@/assets/img/platformIntroduce/mac1.png" />
            <ul class="introduce-business-part2-main-r">
              <li class="introduce-business-part2-main-r-li1 wow fadeInRightBig" data-wow-duration="0.5s">
                <i class="introduce-business-part2-main-r-i1"></i>
                <p><span>01.</span>&nbsp;&nbsp;票面询价</p>
              </li>
              <li class="introduce-business-part2-main-r-li2 wow fadeInRightBig" data-wow-duration="1s">
                <i class="introduce-business-part2-main-r-i2"></i>
                <p><span>02.</span>&nbsp;&nbsp;选择收款账户</p>
              </li>
              <li class="introduce-business-part2-main-r-li3 wow fadeInRightBig" data-wow-duration="1.5s">
                <i class="introduce-business-part2-main-r-i3"></i>
                <p><span>03.</span>&nbsp;&nbsp;补充贸易背景资料</p>
              </li>
              <li class="introduce-business-part2-main-r-li4 wow fadeInRightBig" data-wow-duration="2s">
                <i class="introduce-business-part2-main-r-i4"></i>
                <p><span>04.</span>&nbsp;&nbsp;办理审核</p>
              </li>
              <li class="introduce-business-part2-main-r-li5 wow fadeInRightBig" data-wow-duration="2.5s">
                <i class="introduce-business-part2-main-r-i5"></i>
                <p><span>05.</span>&nbsp;&nbsp;成交放款</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="introduce-business-part3">
        <div class="introduce-business-part3-main main_width">
          <h2 class="wow flipInY">商票速融优势</h2>
          <ul class="introduce-business-part3-list">
            <li class="wow fadeInRightBig" data-wow-duration="0.5s">
              <i class="introduce-business-part3-list-i1"></i>
              <h3>放款快速</h3>
              <p>额度最快当天审批完成<br />商票融资后当天即可放款</p>
            </li>
            <li class="wow fadeInRightBig" data-wow-duration="1s">
              <i class="introduce-business-part3-list-i2"></i>
              <h3>操作便捷</h3>
              <p>用户通过网银提交融资申请<br />足不出户，轻松办理</p>
            </li>
            <li class="wow fadeInRightBig" data-wow-duration="1.5s">
              <i class="introduce-business-part3-list-i3"></i>
              <h3>专属团队服务</h3>
              <p>专属商票速融贴现服务团队<br />专人对接，专业服务</p>
            </li>
            <li class="wow fadeInRightBig" data-wow-duration="2s">
              <i class="introduce-business-part3-list-i4"></i>
              <h3>授信名单广</h3>
              <p>覆盖市场国企、央企、地产等<br />流通热门商票包含500多家授信企业</p>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  mounted () {
    // 初始化动画
    let wow = new this.WOW({
      live: false
    })
    wow.init();
  }
}
</script>

<style scoped lang="stylus">
.main_width
  margin: 0 auto
.introduce
  background-color: #fff
  width: 100%
  overflow: hidden
.banner
  width: 100%
  height: 570px
  color: #fff
  text-align: left
  background: url('~@/assets/img/platformIntroduce/bg1.png') no-repeat center center
  h2
    font-size: 50px
    font-weight: bold
    padding-top: 114px
    line-height: 50px
    margin-bottom: 40px
  p
    /* padding-bottom 22px; */
    font-size: 16px
    width: 578px
    position: relative
    line-height: 30px
  p::after
    content: ''
    position: absolute
    bottom: 0px
    right: 0px
    width: 60px
    height: 4px
    background-color: #fff
.introduce-main
  width: 1190px
  box-shadow: 0px 12px 40px 0px rgba(124, 123, 121, 0.16)
  border-radius: 4px
  position: relative
  margin: 0 auto
  background-color: #fff
  .introduce-main-topImg
    width: 1190px
    height: 560px
    background: url('~@/assets/img/platformIntroduce/bg2.png') no-repeat center center
    position: absolute
    top: -114px
    text-align: left
    display: flex
    .introduce-main-leftImg
      width: 531px
      height: 469px
      background: url('~@/assets/img/platformIntroduce/mac.png') no-repeat center center
      margin-top: 94px
      margin-left: 36px
      margin-right: 70px
    .introduce-main-rightC
      .introduce-main-rightC-topImg
        width: 255px
        height: 189px
        background: url('~@/assets/img/platformIntroduce/yinpiaokuaitie.png') no-repeat center center
        margin-top: 25px
      .introduce-main-rightC-pDiv
        height: 157px
        width: 507px
        display: flex
        align-items: center
        justify-content: center
        position: relative
        p
          width: 546px
          color: #655B5B
          font-size: 16px
          span
            color: #E1241A
            font-weight: bold
      .introduce-main-rightC-pDiv::before
        content: ''
        position: absolute
        width: 46px
        height: 38px
        background: url('~@/assets/img/platformIntroduce/zhuangshi.png') no-repeat center center
        left: 0
        top: -1px
      .introduce-main-rightC-pDiv::after
        content: ''
        position: absolute
        width: 46px
        height: 38px
        background: url('~@/assets/img/platformIntroduce/zhuangshi1.png') no-repeat center center
        right: 0
        bottom: -1px
      .introduce-main-rightC-btn
        width: 219px
        height: 60px
        background: url('~@/assets/img/platformIntroduce/tiexian-btn.png') no-repeat center center
        cursor: pointer
  .introduce-main-top
    height: 446px
    margin-bottom: 60px
  /* 银票快贴与传统银行贴现对比 */
  .introduce-main-bankDifferent
    width: 1130px
    margin: 0 auto
    margin-bottom: 74px
    h2
      line-height: 178px
      font-size: 50px
      color: #121110
      font-weight: 500
      background: url('~@/assets/img/platformIntroduce/01.png') no-repeat center center
      margin-bottom: 26px
    .introduce-main-bankDifferent-main-title
      display: flex
      line-height: 70px
      font-weight: bold
      font-size: 32px
      color: #fff
      .introduce-main-bankDifferent-main-title-l
        background: url('~@/assets/img/platformIntroduce/juxing-red.png') no-repeat center right
        flex: 1
      .introduce-main-bankDifferent-main-title-r
        background: url('~@/assets/img/platformIntroduce/juxing-hui.png') no-repeat center right
        flex: 1
    .introduce-main-bankDifferent-main-list
      li
        display: flex
        height: 130px
        > div
          display: flex
          flex: 1
          align-items: center
        i
          width: 80px
          height: 80px
          margin-right: 28px
          margin-left: 108px
        .introduce-main-bankDifferent-main-list-con
          text-align: left
          p:first-child
            font-size: 24px
            color: #1C2D32
          p:last-child
            font-size: 16px
            color: #5B5D5E
            line-height: 28px
      li:nth-child(2n+1)
        background-color: #fff
      li:nth-child(2n)
        background-color: #EDEDED
      .icon-bank
        background: url('~@/assets/img/platformIntroduce/icon-bank.png') no-repeat center center
      .icon-shijian
        background: url('~@/assets/img/platformIntroduce/icon-shijian.png') no-repeat center center
      .icon-supei
        background: url('~@/assets/img/platformIntroduce/icon-supei.png') no-repeat center center
      .icon-xunzhao
        background: url('~@/assets/img/platformIntroduce/icon-xunzhao.png') no-repeat center center
      .icon-miaoji
        background: url('~@/assets/img/platformIntroduce/icon-miaoji.png') no-repeat center center
      .icon-yewu
        background: url('~@/assets/img/platformIntroduce/icon-yewu.png') no-repeat center center
      .icon-pinzheng
        background: url('~@/assets/img/platformIntroduce/icon-pinzheng.png') no-repeat center center
  /* 在线贴现流程 */
  .introduce-main-online
    width: 1165px
    margin: 0 auto
    padding-bottom: 20px
    h2
      line-height: 178px
      font-size: 50px
      color: #121110
      font-weight: 500
      background: url('~@/assets/img/platformIntroduce/02.png') no-repeat center center
      margin-bottom: 22px
    .introduce-main-online-con
      .wave-line-img
        width: 1165px
        height: 533px
        background: url('~@/assets/img/platformIntroduce/quxian.png') no-repeat center 98px
        list-style: none
        position: relative
        li
          display: inline-block
          position: absolute
        .wave-line-img-li1
          left: 0px
          top: 166px
        .wave-line-img-li2
          left: 241px
          top: 0px
        .wave-line-img-li3
          left: 530px
          top: 230px
        .wave-line-img-li4
          right: 0px
          top: 80px
        .normalStyle
          display: flex
          flex-direction: column
          align-items: center
          .iconCircleStyle
            width: 60px
            height: 60px
            /* background: url('~@/assets/img/platformIntroduce/icon-tijiao@2x.png') no-repeat center center; */
            background-size: 60px
          .line
            width: 3px
            height: 100px
            background-color: #E1241A
            margin-bottom: 11px
          i.san
            width: 21px
            height: 21px
            background: url('~@/assets/img/platformIntroduce/sanjiao.png') no-repeat center center
            position: relative
            margin-left: 14px
          p
            line-height: 56px
            background-color: #EDEDED
            border-radius: 4px
            font-size: 24px
            color: #1C2D32
            padding: 0 14px
            span
              font-size: 32px
              font-weight: bold
              vertical-align: bottom
        .specalStyle
          display: flex
          flex-direction: column
          align-items: center
          .iconCircleStyle
            width: 60px
            height: 60px
            /* background: url('~@/assets/img/platformIntroduce/icon-tijiao@2x.png') no-repeat center center; */
            background-size: 60px
          .line
            width: 3px
            height: 100px
            background-color: #E1241A
            margin-top: 3px
          i.daoSan
            width: 21px
            height: 21px
            background: url('~@/assets/img/platformIntroduce/sanjiao-down.png') no-repeat center center
            position: relative
            margin-right: 14px
          p
            line-height: 56px
            background-color: #EDEDED
            border-radius: 4px
            font-size: 24px
            color: #1C2D32
            padding: 0 14px
            span
              font-size: 32px
              font-weight: bold
              vertical-align: bottom
        .icon-tijiao
          background-image: url('~@/assets/img/platformIntroduce/icon-tijiao@2x.png')
        .icon-huoqu
          background-image: url('~@/assets/img/platformIntroduce/icon-huoqu@2x.png')
        .icon-caozuo
          background-image: url('~@/assets/img/platformIntroduce/icon-caozuo@2x.png')
        .icon-pinzheng
          background-image: url('~@/assets/img/platformIntroduce/icon-pinzheng@2x.png')
.introduce-business-bg
  height: 142px
  background: linear-gradient(0deg, #EBEBEB, #fff)
.introduce-business
  background-color: #fff
  .introduce-business-part1
    background: #fff
    margin: 0 auto
    display: flex
    justify-content: center
    padding-top: 63px
    padding-bottom: 89px
    overflow: hidden
    > div
      flex: 1
    .introduce-business-part1-l
      text-align: left
      margin-right: 82px
      img
        width: 263px
        height: 172px
      p
        text-align: left
        font-size: 16px
        color: #655B5B
        span
          color: #E1241A
          font-weight: bold
      .introduce-business-part1-l-pDiv
        height: 218px
        position: relative
        display: flex
        align-items: center
      .introduce-business-part1-l-pDiv::before
        content: ''
        position: absolute
        width: 46px
        height: 38px
        background: url('~@/assets/img/platformIntroduce/zhuangshi.png') no-repeat center center
        left: 0
        top: -1px
      .introduce-business-part1-l-pDiv::after
        content: ''
        position: absolute
        width: 46px
        height: 38px
        background: url('~@/assets/img/platformIntroduce/zhuangshi1.png') no-repeat center center
        right: 0
        bottom: -1px
      .introduce-business-part1-btn
        cursor: pointer
        width: 221px
        height: 60px
        background: url('~@/assets/img/platformIntroduce/rongzi-btn.png') no-repeat center center
    .introduce-business-part1-r
      background: url('~@/assets/img/platformIntroduce/img@2x.png') no-repeat left center
      background-size: 560px 364px
  .introduce-business-part2
    height: 800px
    background: #F15C44 url('~@/assets/img/platformIntroduce/yuan3.png') no-repeat left 590px
    .introduce-business-part2-main
      background: url('~@/assets/img/platformIntroduce/yuanquan.png') no-repeat center bottom
      height: 100%
      margin: 0 auto
      padding-top: 30px
      display: flex
      flex-direction: column
      h2
        line-height: 178px
        font-size: 50px
        color: #121110
        font-weight: 500
        background: url('~@/assets/img/platformIntroduce/03.png') no-repeat center center
        color: #fff
      > div
        display: flex
        /* align-items center; */
        flex: 1
      .introduce-business-part2-main-l
        width: 607px
        height: 533px
        align-self: flex-end
        margin-bottom: 14px
      .introduce-business-part2-main-r
        li
          display: flex
          align-items: center
          color: #fff
          i
            width: 70px
            height: 70px
            margin-right: 28px
          p
            font-size: 24px
            span
              font-size: 32px
              font-weight: bold
              vertical-align: middle
        .introduce-business-part2-main-r-li1
          margin-top: 35px
          margin-left: 33px
        .introduce-business-part2-main-r-li2
          margin-top: 39px
          margin-left: 143px
        .introduce-business-part2-main-r-li3
          margin-top: 38px
          margin-left: 181px
        .introduce-business-part2-main-r-li4
          margin-top: 39px
          margin-left: 169px
        .introduce-business-part2-main-r-li5
          margin-top: 38px
          margin-left: 108px
        .introduce-business-part2-main-r-i1
          background: url('~@/assets/img/platformIntroduce/icon-xunjia.png') no-repeat center center
        .introduce-business-part2-main-r-i2
          background: url('~@/assets/img/platformIntroduce/icon-xuanze.png') no-repeat center center
        .introduce-business-part2-main-r-i3
          background: url('~@/assets/img/platformIntroduce/icon-ziliao.png') no-repeat center center
        .introduce-business-part2-main-r-i4
          background: url('~@/assets/img/platformIntroduce/icon-shenhe.png') no-repeat center center
        .introduce-business-part2-main-r-i5
          background: url('~@/assets/img/platformIntroduce/icon-fangkuan.png') no-repeat center center
  .introduce-business-part3
    margin-top: 103px
    padding-bottom: 108px
    .introduce-business-part3-main
      margin: 0 auto
    h2
      line-height: 178px
      font-size: 50px
      color: #121110
      font-weight: 500
      background: url('~@/assets/img/platformIntroduce/04.png') no-repeat center center
      color: #121110
    ul
      list-style: none
      margin-top: 138px
      display: flex
      justify-content: space-between
      align-items: center
    li
      display: flex
      align-items: center
      flex-direction: column
      box-shadow: 0px 20px 46px 0px rgba(185, 185, 185, 0.2)
      position: relative
      width: 280px
      padding-top: 73px
      padding-bottom: 41px
      i
        position: absolute
        top: -74px
        width: 100%
        height: 147px
        left: 0
      h3
        color: #333
        font-size: 18px
        font-weight: bold
        line-height: 41px
      p
        color: #999999
        font-size: 14px
        line-height: 16px
    .introduce-business-part3-list-i1
      background: url('~@/assets/img/platformIntroduce/kuaisu.png') no-repeat center center
    .introduce-business-part3-list-i2
      background: url('~@/assets/img/platformIntroduce/bianjie.png') no-repeat center center
    .introduce-business-part3-list-i3
      background: url('~@/assets/img/platformIntroduce/tuandui.png') no-repeat center center
    .introduce-business-part3-list-i4
      background: url('~@/assets/img/platformIntroduce/shouxin.png') no-repeat center center
</style>



// WEBPACK FOOTER //
// src/components/platformIntroduce/PlatformIntroduce.vue